import { SvgIcon } from '@material-ui/core';
import { ReactComponent as reward } from './reward.svg';

export default function RewardIcon(props) {
  return <SvgIcon {...props} component={reward} viewBox="0 0 12 12" />;
}
